import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import { createTeraSync } from '@iebh/vuex-tera-json';
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Import $tera / @iebh/Tera-fy global service
// NOTE: See bottom of file inside main async() init loop for when TeraFy actually boots
import TeraFy from '@iebh/tera-fy/dist/terafy.es2019.js'; // FIX: Use annoyingly old and specific version as Babel struggles with ESNEXT class imports
import TerafyVue from '@iebh/tera-fy/dist/plugin.vue2.es2019.js';

let terafy = new TeraFy()
	.set("verbosity", process.env.VUE_APP_TERAFY_VERBOSITY || 1)
	.setIfDev("devMode", process.env.VUE_APP_TERAFY_DEV == 1)
	.setIfDev("siteUrl", process.env.VUE_APP_TERAFY_URL)
	.use(TerafyVue); // Add the Vue plugin

// Register all Input/Base Components Globally {{{
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

const requireComponent = require.context(
	// The relative path of the components folder
	"./components",
	// Whether or not to look in subfolders
	false,
	// The regular expression used to match base component filenames
	/(Input|Base)[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName);

	// Get PascalCase name of component
	const componentName = upperFirst(
		camelCase(
			// Gets the file name regardless of folder depth
			fileName
				.split("/")
				.pop()
				.replace(/\.\w+$/, "")
		)
	);

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	);
});
// }}}

// --- TERA Sync Plugin Initialization ---
const teraSyncApi = createTeraSync({
	keyPrefix: 'disputatron',
	isSeparateStateForEachUser: false,
	// autoSaveIntervalMinutes: 15 // This defaults to 15
}, store);

// Make the API accessible globally
Vue.prototype.$teraSync = teraSyncApi;
// --- End TERA Sync Plugin Initialization ---

// Boot Vue + Tera
(async () => {
	const app = new Vue({
		store,
		render: h => h(App),
		beforeDestroy() {
			// Cleanup
			if (teraSyncApi && typeof teraSyncApi.destroy === 'function') {
				console.log("Destroying TERA Sync Plugin");
				teraSyncApi.destroy();
			}
		}
	});

	// DEBUG
	window.vueInstance = app;

	// --- Set the Vue instance for the teraSyncApi ---
	if (teraSyncApi && typeof teraSyncApi.setVueInstance === 'function') {
		teraSyncApi.setVueInstance(app);
	} else {
		console.error("Failed to set Vue instance on TERA Sync API object.");
	}

	// Boot teraFy + require project + pull & subscribe to project data
	try {
		await terafy.init({
			app,
			Vue,
		});

		// --- Set TERA ready ---
		if (teraSyncApi && typeof teraSyncApi.setTeraReady === 'function') {
			console.log("Setting TERA Ready on Sync Plugin");
			await teraSyncApi.setTeraReady();
		} else {
			console.error("Failed to set TERA Ready on TERA Sync API object.");
		}

	} catch (error) {
		console.error("TeraFy initialization failed:", error);
	}

	app.$mount("#app");
})();